import Button from "@mui/material/Button";
import { colors } from "../../theme/colors";

export type HeaderButton = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
};

type Props = {
  headerButtons: HeaderButton[];
};

export const HeaderButtons = ({ headerButtons }: Props) => {

  return (
    <>
      {headerButtons.map((button, index) => (
        <Button
          key={index}
          variant="contained"
          sx={{
            mr: 2,
            color: "white",
            backgroundColor: colors.primary,
            borderRadius: "20px",
            "&:hover": {
              backgroundColor: colors.primary,
              transform: "scale(1.025)",
            },
            fontWeight: "bold",
          }}
          onClick={button.onClick}
        >
          {button.label}
        </Button>
      ))
      }
    </>
  )
}
